// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BalloonTypeSelection_wrapper__3psUS","title":"BalloonTypeSelection_title__2VtzD","sectionTitle":"BalloonTypeSelection_sectionTitle__aivAu"};